const BlockNavigationReducer = (state = {show: false}, action) => {
  const {type, msg, component, unblocker} = action

  switch (type) {
    case "BLOCK_NAVIGATION_BLOCK":
      return {...state, msg, component}
    case "BLOCK_NAVIGATION_TRIGGER_CONFIRM":
      return {...state, unblocker, show: true}
    case "BLOCK_NAVIGATION_UNBLOCK":
      return {show: false}
    case "BLOCK_NAVIGATION_HIDE":
      return {...state, unblocker: null, show: false}
    case "BLOCK_NAVIGATION_UPDATE_COMPONENT":
      return {...state, component}
    default:
      return state
  }
}

export default BlockNavigationReducer
